import { useSnapshot } from 'valtio';

import DashboardAdmin from '../../components/pages/backoffice/dashboard/admin.jsx';
import DashboardBackofficeUser from '../../components/pages/backoffice/dashboard/backoffice-user.jsx';
import { authState } from '../../services/state/auth-state.jsx';

export const Dashboard = () => {
  const { isAdmin } = useSnapshot(authState);

  if (isAdmin) {
    return <DashboardAdmin />;
  } else {
    return <DashboardBackofficeUser />;
  }
};
